module.exports = __webpack_public_path__ + "static/media/buy_customer_support_2.115c6b21.png";